import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import TopicsSingle from '../containers/TopicsSingle'
import ScheduleSingle from '../containers/ScheduleSingle'
import AllTimeScheduleSingle from '../containers/AllTimeScheduleSingle'
import TourSingle from '../containers/TourSingle'

class Single extends Component {
  constructor(props) {
    super()
    this.category = props.category
    this.path = props.history.location.pathname // 現在のパス
  }

  render() {
    const { data } = this.props
    const parentPath = new RegExp(this.category, 'g')
    const childPath = this.path.replace(parentPath, '').replace(/\//g, '')
    const selectedData = Array.from(data).filter(e => e.slug === childPath)[0]

    // TOPICS singleテンプレート
    if (this.category === 'topics') {
      return <TopicsSingle data={selectedData} />
    }

    // SCHEDULE singleテンプレート
    if (this.category === 'schedule') {
      return <ScheduleSingle data={selectedData} />
    }

    // ALL TIME SCHEDULE singleテンプレート
    if (this.category === 'alltimeschedule') {
      return <AllTimeScheduleSingle data={selectedData} />
    }

    // TOUR singleテンプレート
    if (this.category === 'tour') {
      return <TourSingle data={selectedData} />
    }
    return null
  }
}

export default withRouter(Single)

Single.propTypes = {
  data: PropTypes.array,
  category: PropTypes.string,
  history: PropTypes.object,
}

Single.defaultProps = {
  data: null,
  category: null,
  history: null,
}
